import { getAnalyticsTracker, setAnalyticsPage } from "analytics";
import booksAnimation from "assets/images/lotties/books.json";
import noordhoff from "assets/images/png/noordhofflogo.png";
import AnimatedImg from "components/AnimatedImg/AnimatedImg";
import { Button } from "components/Button";
import { useBook } from "hooks/useBook";
import { Footer } from "layout/Footer";
import { observer } from "mobx-react";
import queryString from "query-string";
import type React from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import { redirectToIdpLogin } from "utils/idp";
import type { QueryParams } from "utils/urlBuilder";

import {
  StyleBookTitle,
  StyleContent,
  StyleImgContainer,
  StyleLeftColumn,
  StyleParagraph,
  StyleSignInContainer,
  StyleStep,
  StyleTitle,
  StyledStudiemeister,
} from "./SignIn.styled";

export const SignIn: React.FC = observer(() => {
  const { fetchBookTitle, bookTitle } = useBook();
  const { t } = useTranslation("signIn");
  const locationSearch = useHistory().location.search;
  const queryParamsPath = queryString.parse(locationSearch) as QueryParams;
  const { search } = useLocation();
  const bookId = search.split("/")[1];

  useEffect(() => {
    if (getAnalyticsTracker()) {
      setAnalyticsPage("", "signin");
    }
  }, []);

  useEffect(() => {
    bookId && fetchBookTitle(bookId);
  }, [bookId, fetchBookTitle]);

  return (
    <StyleSignInContainer>
      <StyleLeftColumn>
        <StyledStudiemeister alt="sign-in" src={noordhoff} />
        <StyleContent>
          <StyleTitle>{t("title")}</StyleTitle>
          <StyleBookTitle data-cy="book-title">{bookTitle}</StyleBookTitle>
          <StyleParagraph>{t("body")}</StyleParagraph>
          <StyleStep>
            <span>{t("step1")}</span>
            {t("step1text")}
          </StyleStep>
          <StyleStep>
            <span>{t("step2")}</span>
            {t("step2text")}
          </StyleStep>
          <StyleStep>
            <span>{t("step3")}</span>
            {t("step3text")}
          </StyleStep>
          <Button
            dataCy="sign-in-button"
            height={48}
            variant="primary"
            width={240}
            onClick={() => redirectToIdpLogin(queryParamsPath)}
          >
            {t("buttonCaption")}
          </Button>
        </StyleContent>
        <Footer />
      </StyleLeftColumn>
      <StyleImgContainer>
        <AnimatedImg src={booksAnimation} />
      </StyleImgContainer>
    </StyleSignInContainer>
  );
});
